import './LandBottomLayout.css'
import 'antd/dist/reset.css'
import React from 'react'
import { Divider } from 'antd'
import { getMainThemeProducts } from '../../products/ProductProvider'
import Emblem from '../../images/widget/emblem.png'

export default class LandBottomLayout extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {}

  render() {
    return (
      <div className="LandBottomLayout">
        <Divider style={{ borderColor: 'gray', height: 10 }} />

        <div className="LandBottomMenuWrapper">
          <div className="LandBottomMenu">
            <div className="LandBottomMenuTitle">产品</div>
            <div
              className="LandBottomMenuItem"
              onClick={() => this.viewProductDetail(getMainThemeProducts()[0])}
            >
              {getMainThemeProducts()[0].name}
            </div>
            <div
              className="LandBottomMenuItem"
              onClick={() => this.viewProductDetail(getMainThemeProducts()[1])}
            >
              {getMainThemeProducts()[1].name}
            </div>
            <div
              className="LandBottomMenuItem"
              onClick={() => this.viewProductDetail(getMainThemeProducts()[2])}
            >
              {getMainThemeProducts()[2].name}
            </div>
          </div>

          <div className="LandBottomMenu">
            <div className="LandBottomMenuTitleInvisible">产品</div>
            <div
              className="LandBottomMenuItem"
              onClick={() => this.viewProductDetail(getMainThemeProducts()[3])}
            >
              {getMainThemeProducts()[3].name}
            </div>
            <div
              className="LandBottomMenuItem"
              onClick={() => this.viewProductDetail(getMainThemeProducts()[4])}
            >
              {getMainThemeProducts()[4].name}
            </div>
            <div
              className="LandBottomMenuItem"
              onClick={() => this.viewProductList()}
            >
              全部产品
            </div>
          </div>

          <div className="LandBottomMenu">
            <div className="LandBottomMenuTitle">Keystride创新</div>
            <div
              className="LandBottomMenuItem"
              onClick={() => this.viewProductLine()}
            >
              定制化柔性生产线
            </div>
            <div
              className="LandBottomMenuItem"
              onClick={() => this.viewOverallSolution()}
            >
              整体解决方案
            </div>
            <div
              className="LandBottomMenuItem"
              onClick={() => this.viewOnsiteGuidance()}
            >
              现场工程指导
            </div>
          </div>

          <div className="LandBottomMenu">
            <div className="LandBottomMenuTitle">公司</div>
            <div
              className="LandBottomMenuItem"
              onClick={() => this.viewCompanyInfo()}
            >
              公司介绍
            </div>
            <div
              className="LandBottomMenuItem"
              onClick={() => this.viewCertificates()}
            >
              资质证书
            </div>
            <div
              className="LandBottomMenuItem"
              onClick={() => this.viewContactMethod()}
            >
              联系方式
            </div>
          </div>

          <div className="LandBottomMenu">
            <div className="LandBottomMenuTitle">法律</div>
            <div
              className="LandBottomMenuItem"
              onClick={() => this.viewContractTerms()}
            >
              KeyStride条款与条件
            </div>
          </div>
        </div>

        <Divider
          style={{ borderColor: 'gray', height: 10, marginBottom: '1vh' }}
        />

        <div
          className="LandDomain"
          onClick={() => {
            window.open(
              'https://beian.miit.gov.cn/#/Integrated/index',
              '_blank'
            )
          }}
        >
          <div className="LandDomainCopyright">
            版权所有 © 2025 江苏凯士达阀门科技有限公司保留所有权
          </div>
          <img className="LandDomainEmblem" src={Emblem} />
          <div
            className="LandDomainGonganBeian"
            onClick={() => {
              window.open(
                'https://beian.mps.gov.cn/#/query/webSearch?code=32118202001106',
                '_blank'
              )
            }}
          >
            苏公网安备32118202001106号
          </div>
          <div
            className="LandDomainIcpBeian"
            onClick={() => {
              window.open(
                'https://beian.miit.gov.cn/#/Integrated/index',
                '_blank'
              )
            }}
          >
            苏ICP备2025182856号-1
          </div>
        </div>
      </div>
    )
  }

  viewProductDetail = (product) => {
    this.props.history.push('/product?pid=' + product.pid)
  }

  viewProductList = () => {
    this.props.history.push('/product_list')
  }

  viewProductLine = () => {
    this.props.history.push('/product_line')
  }

  viewOverallSolution = () => {
    this.props.history.push('/overall_solution')
  }

  viewOnsiteGuidance = () => {
    this.props.history.push('/onsite_guidance')
  }

  viewCompanyInfo = () => {
    this.props.history.push('/company')
  }

  viewCertificates = () => {
    this.props.history.push('/certificates')
  }

  viewContactMethod = () => {
    this.props.history.push('/contact')
  }

  viewContractTerms = () => {
    this.props.history.push('/contract_terms')
  }

  viewPrivacyPolicy = () => {
    this.props.history.push('/privacy_policy')
  }
}
